import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
// import MessengerCustomerChat from 'react-messenger-customer-chat';
import FingotiNav from '@fingoti/nav';
import { useFingotiAuth } from '@fingoti/auth-js/react';
import { FingotiButton } from '@fingoti/components';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { useProfileState } from '../context/ProfileContext';
import { apiService } from '../services/api.service';
import * as appConfig from '../services/config';

const useStyles = makeStyles(theme => ({

    root: {
        maxWidth: '100%',
        padding: theme.spacing(1),
        margin: 0,
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(100% - 114px);',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: theme.spacing(3),
        }
    },

    contextBanner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(1, 2),
        background: theme.palette.secondary.main,
        color: theme.palette.common.white,
        borderRadius: 0,
    },

}))

const Layout = ({ children }) => {

    const history = useHistory();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { orgContext, isHomeOrg, isActingAs, enterOrgContext, exitOrgContext, exitToHomeOrg } = useFingotiAuth();
    const { organisation } = useProfileState();

    const handleExitOrgContext = async () => {
        try {
            // Pops a single level: revokes only the current level's family and
            // restores the immediate parent. From a nested context this lands one
            // org up rather than all the way home.
            await exitOrgContext();
            // App refetches the profile when the context chain changes.
            history.push('/organisation');
        } catch (error) {
            enqueueSnackbar(
                error?.description ?? error?.message ?? 'Unable to exit organisation',
                { variant: 'error' }
            );
        }
    }

    const handleExitToHomeOrg = async () => {
        try {
            // Unwinds every nested level (deepest first) and restores the home
            // session in one call.
            await exitToHomeOrg();
            history.push('/organisation');
        } catch (error) {
            enqueueSnackbar(
                error?.description ?? error?.message ?? 'Unable to return to your organisation',
                { variant: 'error' }
            );
        }
    }

    const handleSideNavClick = (link) => {
        history.push(link);
    }

    const handleBackClick = () => {
        history.goBack();
    }

    const handleSwitchOrganisation = async (oid) => {
        try {
            // Contexts nest: from a non-home context this drills one level deeper
            // (current org → target). The server resolves each hop to a membership
            // switch or act-as based on the user's membership of the target, and
            // only rejects re-entering the org we're already in.
            await enterOrgContext(oid);
            history.push('/organisation');
        } catch (error) {
            enqueueSnackbar(
                error?.description ?? error?.message ?? 'Unable to switch organisation',
                { variant: 'error' }
            );
        }
    }

    const handleLogout = () => {
        history.push('/logout');
    }

    return (
        <React.Fragment>
            <FingotiNav
                onSideNavClick={handleSideNavClick}
                onBackClick={handleBackClick}
                currentApp="account"
                useProfileState={useProfileState}
                handleSwitchOrganisation={handleSwitchOrganisation}
                apiService={apiService}
                handleLogout={handleLogout}
                config={appConfig}
            />
            {!isHomeOrg && orgContext &&
                <Paper className={classes.contextBanner} elevation={0} square>
                    <Typography variant="body2">
                        {`${isActingAs ? 'You are acting as' : 'You are viewing'} ${organisation?.organisationName ?? orgContext.targetOid}`}
                        {orgContext.depth > 1 && ` (${orgContext.depth} levels deep)`}
                    </Typography>
                    <FingotiButton light color="secondary" onClick={handleExitOrgContext}>
                        {orgContext.depth > 1 ? 'back one level' : 'exit'}
                    </FingotiButton>
                    {orgContext.depth > 1 &&
                        <FingotiButton light color="secondary" onClick={handleExitToHomeOrg}>
                            exit to home
                        </FingotiButton>
                    }
                </Paper>
            }
            <Container className={classes.root}>
                {children}
            </Container>
            {/* {isDesktop &&
                <MessengerCustomerChat
                    pageId="215950192435406"
                    htmlRef={window.location.pathname}
                />
            } */}
        </React.Fragment>
    );
}

export default Layout;
